const recruteurDashboardGuideSteps = [
  {
    target: '.guide-dashboard',
    content: "Bienvenue sur votre espace Recruteur. Suivez ici votre activité, vos résultats et les dernières actualités de vos missions."
  },
  {
    target: '.guide-missions',
    content: "Consultez les missions disponibles, positionnez-vous rapidement et suivez leur statut en un clic."
  },
  {
    target: '.guide-candidatures',
    content: "Gérez vos candidatures en cours et suivez leur avancement auprès des entreprises."
  },
  {
    target: '.guide-topmatches',
    content: "Découvrez vos meilleurs matchs IA : les opportunités les plus pertinentes selon les profils de votre vivier et les talents déjà en base."
  },
  {
    target: '.guide-talents',
    content: "Conservez et gérez votre vivier de talents IT. Centralisez vos profils et retrouvez-les facilement pour vos missions."
  },
  {
    target: '.guide-stats',
    content: "Suivez vos performances : candidatures envoyées, profils recrutés, taux de réussite et progression."
  },
  {
    target: '.guide-dernieres-missions',
    content: "Consultez les nouvelles missions publiées et restez informé des opportunités en temps réel."
  },
  {
    target: '.guide-niveau',
    content: "Découvrez votre niveau et votre progression. Plus vous placez de talents, plus votre réputation grandit !"
  },
  {
    target: '.guide-cagnotte',
    content: "Visualisez le montant disponible dans votre cagnotte et vos gains prêts à être retirés."
  },
  {
    target: '.guide-prime',
    content: "Suivez le montant total que vous pourriez percevoir selon les missions actives et les profils en cours de placement."
  }
];

export default recruteurDashboardGuideSteps;
